import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const updateMargin = async (margin) => {
  try {
    console.log('Updating margin:', margin);
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const URL = routes.GET_MARGIN;
    const response = await axios.put(URL, {margin}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching settings:', error);
    throw error;
  }
};

export default updateMargin;